import React from 'react';
import './TrustSignals.scss';

const TrustSignals = () => (
  <section className="trust-signals">
    <div className="container">
      <h3>Trusted By Leading Brands</h3>
      <div className="brand-logos">
        <div className="brand-logo">
          <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Toyota_carlogo.svg/800px-Toyota_carlogo.svg.png" alt="Toyota" />
        </div>
        <div className="brand-logo">
          <img src="https://i.ibb.co/BKtvJvBD/Honda-Symbol-Logo-transparent-PNG-Stick-PNG.jpg" alt="Honda" />
        </div>
        <div className="brand-logo">
          <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Ford_logo_flat.svg/800px-Ford_logo_flat.svg.png" alt="Ford" />
        </div>
        <div className="brand-logo">
          <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/BMW.svg/800px-BMW.svg.png" alt="BMW" />
        </div>
        <div className="brand-logo">
          <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Mercedes-Logo.svg/800px-Mercedes-Logo.svg.png" alt="Mercedes" />
        </div>
        <div className="brand-logo">
          <img src="https://i.ibb.co/wN8k5Mnx/VOLVO-LOGO.jpg" alt="Volvo" />
        </div>
      </div>
    </div>
  </section>
);

export default TrustSignals;
